import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import { getIsOrangeComboButtonEnabled, getIsTariffAccumsFttbDivideEnabled } from '@beef/elk-common';
import { OrangeComboButton } from "../../../../OrangeCombo";
import { selectConvergentDataError, selectConvergentDataPending, selectIsConvergent, selectMobileConnectionBlockError } from "../../store/selectors";
import { selectBillingDate } from "./store";
import { Card } from "../../../Card";
import { Accumulators } from "../Accumulators";
import { BillingDate } from "../BillingDate";
import { ManageTariffButton } from "../ManageTariffButton";
import { ConvergentTariffTitle } from "./ConvergentTariffTitle";
import { ConvergentAddress } from "../ConvergentAddress";
import { ConvergentAccumulators } from "../ConvergentAccumulators";
import { Skeleton } from "../Skeleton";
import { TariffError } from "../TariffError";
import { ConnectionBlockActionCreator } from "../../store/actions";
import { selectConnectUrl } from "../../Mobile/store";
var _ConvergentTariff = function _ConvergentTariff(_ref) {
  var billingDate = _ref.billingDate,
    connectionUrl = _ref.connectionUrl,
    pending = _ref.pending,
    isError = _ref.isError,
    fetchMobileConnection = _ref.fetchMobileConnection,
    fetchConvergent = _ref.fetchConvergent;
  var showOrangeCombo = getIsOrangeComboButtonEnabled();
  var handleRefreshIconClick = function handleRefreshIconClick() {
    fetchMobileConnection();
    fetchConvergent();
  };
  if (pending) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      "data-t-id": "components-ConvergentTariff"
    });
  }
  if (isError) {
    return /*#__PURE__*/React.createElement(TariffError, {
      onClick: handleRefreshIconClick
    });
  }
  return /*#__PURE__*/React.createElement(Card, {
    color: "primary",
    href: connectionUrl,
    size: "m"
  }, /*#__PURE__*/React.createElement(ConvergentTariffTitle, {
    "data-t-id": "components-ConvergentTariff"
  }), /*#__PURE__*/React.createElement(Accumulators, null), /*#__PURE__*/React.createElement(ManageTariffButton, {
    tariffUrl: connectionUrl
  }), showOrangeCombo && /*#__PURE__*/React.createElement(OrangeComboButton, null), /*#__PURE__*/React.createElement(ConvergentAddress, null), /*#__PURE__*/React.createElement(ConvergentAccumulators, null), /*#__PURE__*/React.createElement(BillingDate, {
    billingDate: billingDate,
    isComposeBillingDate: true
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var pending = selectConvergentDataPending(state);
  var isError = selectConvergentDataError(state) || selectMobileConnectionBlockError(state);
  return {
    billingDate: selectBillingDate(state),
    connectionUrl: selectConnectUrl(state),
    pending: pending,
    isError: isError,
    shouldRender: selectIsConvergent(state) && !getIsTariffAccumsFttbDivideEnabled()
  };
};
var mapDispatchToProps = {
  fetchMobileConnection: ConnectionBlockActionCreator.fetchMobileConnection,
  fetchConvergent: ConnectionBlockActionCreator.fetchConvergent
};
export var ConvergentTariff = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_ConvergentTariff);